$.fn.DetailsSummary = function(_element)
{
	var _ds = this;
	_ds.details_template;
	_ds.element = _element;
	
	_ds.setDetails = function(details_items)
	{
		_ds.empty();
		details_items.forEach(function(x)
		{
			// get item details
			var item = x.model.item,
			itemTitle = x.getDetailsTitle();
			var detailsLine = _ds.details_template.clone(),
			item_type = !itemTitle || itemTitle == " " || itemTitle == " " ? "–" : itemTitle,
			received = !x.model.getBase() ? 0 : x.model.getBase(),
			due = !x.model.getDue() ? 0 : x.model.getDue();
			received = received.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			due = due.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			});
			
			// get value and display type
			var value = !item.value ? "–" : item.value,
			config = x.dl.details_tab.e.getConventionItems();
			if (item != undefined && item.item_type != 0 && item.item_type != "NONE" && item.item_type != undefined && config[item.item_type] != undefined){
				config_type = config[item.item_type].calc[0];
				switch (config_type){
					case '$':
					value = '–';
					break;
					case '%':
					value = parseInt(value, 10);
					value += "%";
					break;
				}
			};
			
			if (_ds.element.el.form.get_invoice_type() == 3) {
				detailsLine.find(".cell-value").text(received + ' $');
				detailsLine.find(".cell-tax_exempt").text(x.model.item.tax_exempt ? 'Sans taxe' : '–');
			} else {
				detailsLine.find(".cell-value").text(value);
			}
			detailsLine.find(".cell-desc").text(item_type);
			detailsLine.find(".cell-received").text(received);
			detailsLine.find(".cell-due").text(due);
			_ds.append(detailsLine);
		});
	};
	
	return function()
	{
		// template
		_ds.details_template = _ds.find(".slr-el-row-template").clone();
		_ds.details_template.removeClass("slr-el-row-template");
		_ds.find(".slr-el-row-template").remove();
		return _ds;
	}();
}
